module.exports = __webpack_public_path__ + "img/caas4-m@1.68a20dbe.jpg";